var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"searchPtenDeduplicate"}},[_c('headerPtenDeduplicate',{staticClass:"mt-16",on:{"actionClick":_vm.actionClick}}),_c('tablePten',{ref:"tablePten",staticClass:"mt-0 px-3",attrs:{"list":"deduplicate"},on:{"actionClick":_vm.actionClick}}),_c('navbarPten',{attrs:{"menuIndex":"0"},on:{"actionClick":_vm.actionClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }